import graphqlClient from "@/GQLClient";
import type { CategoryFragment } from "@/graphql";
import {
  type CategoryInput,
  SaveCategoryDocument,
  Category_Type,
  DeleteCategoryDocument,
  GetCategoriesDocument,
  GetEventCountOnRelatedCategoryDocument,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";

const getCategories = async (
  type: Category_Type,
): Promise<CategoryFragment[]> => {
  const response = await graphqlClient.query({
    query: GetCategoriesDocument,
    variables: {
      type,
    },
  });

  if (response.data.category?.get) {
    return response.data.category.get.filter((item) => item !== null);
  }

  throw new SentryGraphQLError();
};

const save = async (type: Category_Type, category: CategoryInput) => {
  const response = await graphqlClient.mutate({
    mutation: SaveCategoryDocument,
    variables: {
      category,
      type,
    },
  });

  if (response.data?.category?.save?.success) {
    return response.data.category.save;
  }

  throw new SentryGraphQLError();
};

const deleteItem = async (type: Category_Type, id: string) => {
  const response = await graphqlClient.mutate({
    mutation: DeleteCategoryDocument,
    variables: {
      id,
      type,
    },
  });

  if (response.data?.category?.delete?.success) {
    return response.data.category.delete;
  }

  throw new SentryGraphQLError();
};

const getEntityCountOnRelatedCategory = async (
  type: Category_Type,
  categoryId: number,
): Promise<number> => {
  const response = await graphqlClient.query({
    query: GetEventCountOnRelatedCategoryDocument,
    variables: {
      type,
      ids: [categoryId.toString()],
    },
  });

  if (response.data.category?.get && response.data.category?.get.length) {
    const [category] = response.data.category.get;
    return category?.entities?.totalCount || 0;
  }

  throw new SentryGraphQLError();
};

export default {
  getCategories,
  save,
  deleteItem,
  getEntityCountOnRelatedCategory,
};
